import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToolbox, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Form from '../../components/Form/Form';
import InputText from '../../components/Form/Fields/InputText';
import InputPassword from '../../components/Form/Fields/InputPassword';
import { useBackofficeAuth } from '../../context/BackofficeAuthProvider';

export default function BackofficeLogin() {
    const { admin, loading, login } = useBackofficeAuth();
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        document.title = 'Backoffice — Connexion';
    }, []);

    if (!loading && admin) {
        return <Navigate to="/backoffice/help" replace />;
    }

    // No manual navigate() here on success — that would race the "admin" context update
    // above (navigate can render PlatformAdminRoute's guard before the provider commits
    // the new admin value, bouncing straight back to /backoffice/login). Once login()
    // resolves, the context updates, this component re-renders, and the reactive
    // <Navigate> above fires with the already-current admin value.
    const handleLogin = (data) => {
        setIsSubmitting(true);
        login(data.username, data.password)
            .catch((err) => toast.error(err.response?.data?.message || 'Identifiants invalides.'))
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0f172a',
        }}>
            <div style={{
                width: '100%',
                maxWidth: 380,
                background: '#fff',
                borderRadius: 16,
                padding: '36px 32px',
                boxShadow: '0 20px 40px rgba(0,0,0,0.25)',
            }}>
                <div className="text-center mb-4">
                    <div style={{
                        width: 48, height: 48, borderRadius: 12,
                        background: '#e0e7ff', color: '#4338ca',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 14px', fontSize: 20,
                    }}>
                        <FontAwesomeIcon icon={faToolbox} />
                    </div>
                    <h5 className="fw-bold mb-1">Backoffice</h5>
                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>Accès réservé à l'administration de la plateforme</p>
                </div>

                <Form id="backofficeLoginForm" onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label" htmlFor="username">Identifiant</label>
                        <InputText
                            id="username"
                            name="username"
                            disabled={isSubmitting}
                            autofocus={true}
                            autoComplete="username"
                            validationRules={{ required: "L'identifiant est requis" }}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="form-label" htmlFor="password">Mot de passe</label>
                        <InputPassword
                            name="password"
                            disabled={isSubmitting}
                            validationRules={{ required: 'Le mot de passe est requis' }}
                        />
                    </div>

                    <button type="submit" className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2" disabled={isSubmitting}>
                        {isSubmitting ? <span className="spinner-border spinner-border-sm" /> : (
                            <>Se connecter <FontAwesomeIcon icon={faArrowRight} /></>
                        )}
                    </button>
                </Form>
            </div>
        </div>
    );
}
